angular.module("app")

.config(['$provide', function ($provide) {

    //sobreescribimos metodos de ui-grid-exporter
    $provide.decorator('uiGridExporterService', ["$filter", "$delegate", function ($filter, $delegate) {
        $delegate.pdfExport = function (grid, rowTypes, colTypes) {
            var self = this;
            this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function () {
                var exportColumnHeaders = self.getColumnHeaders(grid, colTypes);
                angular.forEach(exportColumnHeaders, function (header) {
                    angular.forEach(grid.columns, function (column) {
                        if (column.field == header.name) {
                            header.colDef = column.colDef;
                        }
                    });
                });
                $delegate.exportColumnsTmp = exportColumnHeaders;

                var exportData = self.getData(grid, rowTypes, colTypes);
                var docDefinition = self.prepareAsPdf(grid, exportColumnHeaders, exportData);
                if (self.isIE()) {
                    self.downloadPDF(grid.options.exporterPdfFilename, docDefinition);
                } else {
                    // @ts-ignore
                    pdfMake.createPdf(docDefinition).download(grid.options.pdfTitle + '.pdf');
                    //pdfMake.createPdf(docDefinition).open();
                    //.gridOptions.gridApi.exporter.pdfExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
                }
            });
        };
        $delegate.formatRowAsPdf = function (exporter) {
            return function (row) {
                return row.map(exporter.formatFieldAsPdfString);
            };
        };
        $delegate.formatFieldAsPdfString = function (field, idx) {
            var returnVal;
            var column = $delegate.exportColumnsTmp[idx];
            if (angular.isDefined(column.colDef) && angular.isDefined(column.colDef.customFormatFn)) {
                returnVal = column.colDef.customFormatFn(field.value);
            } else {
                if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
                    returnVal = '';
                } else if (typeof (field.value) === 'number') {
                    returnVal = field.value.toString();
                } else if (typeof (field.value) === 'boolean') {
                    returnVal = (field.value ? 'Si' : 'No');
                } else if (typeof (field.value) === 'string') {
                    //comprobamos si tiene tipo
                    if (angular.isDefined(column.colDef) && angular.isDefined(column.colDef.type)) {
                        if (column.colDef.type == "date") {
                            returnVal = $filter('date')(field.value, "dd/MM/yyyy HH:mm:ss");
                        } else {
                            returnVal = field.value.replace(/"/g, '""');
                        }
                    } else {
                        returnVal = field.value.replace(/"/g, '""');
                    }
                } else {
                    returnVal = JSON.stringify(field.value).replace(/^"/, '').replace(/"$/, '');
                }

            }

            if (field.alignment && typeof (field.alignment) === 'string') {
                returnVal = { text: returnVal, alignment: field.alignment };
            }

            return returnVal;
        };
        return $delegate;
    }]);


}])

    .factory("gridService", ['uiGridConstants', 'Restangular', '$timeout', '$filter', function (uiGridConstants, Restangular, $timeout, $filter) {
    var service = {
        yesNoTemplate: function (propertyName) {
            return "<div class=\"ui-grid-cell-contents\">{{row.entity." + propertyName + "?'Si':'No'}}</div>";
        },

        hourTemplate: function () {
            return "<div><form name=\"inputForm\"><input ng-class=\"'colt' + col.uid\" type=\"text\" ui-mask=\"99:99:99\" ui-options=\"{{grid.appScope.maskOptions}}\" ui-mask-placeholder ui-mask-placeholder-char=\"_\" model-view-value=\"true\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\"></form></div>";
        },

        linkTemplate: function (value, linkRef, linkId) {
            return "<div class=\"ui-grid-cell-contents\">{{row.entity." + value + "}} <a ui-sref=\"" + linkRef + ".edit({id: row.entity." + linkId + "})\"> <i class=\"fa fa-share-square-o\"> </i> </a></div>";
        },
        actionTemplate: function (actions, options) {
            var ret = "";
            angular.forEach(actions, function (action) {
                var cssClass = "btn btn-xs btn-default btn-outline";
                if (typeof action.cssClass != "undefined") cssClass = action.cssClass;
                ret += "<a class=\"" + cssClass + "\" " + action.action + "><i class=\"" + action.cssIconClass + "\"></i>&nbsp;" + action.title + "</a>\n";
            });
            var cssClass = "";
            if (angular.isDefined(options)) {
                if (angular.isDefined(options.cssClass)) cssClass = options.cssClass;
            }
            return "<div class=\"ui-grid-cell-contents " + cssClass + "\">" + ret + "</div>";
        },
        actionIconNoSpaceTemplate: function (actions, options) {
            var ret = "";
            angular.forEach(actions, function (action) {
                var cssClass = "btn btn-xs btn-default btn-outline";
                if (typeof action.cssClass != "undefined") cssClass = action.cssClass;
                ret += "<a class=\"" + cssClass + "\" " + action.action + "><i class=\"" + action.cssIconClass + "\"></i>" + action.title + "</a>\n";
            });
            var cssClass = "";
            if (angular.isDefined(options)) {
                if (angular.isDefined(options.cssClass)) cssClass = options.cssClass;
            }
            return "<div class=\"ui-grid-cell-contents " + cssClass + "\">" + ret + "</div>";
        },
        actionIconTemplate: function (actions, options) {
            var ret = "";
            angular.forEach(actions, function (action) {
                var cssClass = "btn btn-xs aColorGrey";
                if (typeof action.cssClass != "undefined") cssClass = action.cssClass;
                ret += "<a class=\"" + cssClass + "\" " + action.action + "><i class=\"" + action.cssIconClass + "\"></i>&nbsp;" + action.title + "</a>\n";
            });
            var cssClass = "";
            if (angular.isDefined(options)) {
                if (angular.isDefined(options.cssClass)) cssClass = options.cssClass;
            }
            return "<div class=\"ui-grid-cell-contents " + cssClass + "\">" + ret + "</div>";
        },
        yesNoFilter: function (propertyName) {
            return {
                term: "",
                type: uiGridConstants.filter.SELECT,
                selectOptions: [{ value: 'true', label: 'Si' }, { value: 'false', label: 'No' }]
            };
        },
        colorTemplate: function (field_name, tree_level) {  
            return "<div class=\"ui-grid-cell-contents\" ng-switch=\"row.entity.message_level\"><span id=\"{{row.entity." + tree_level + "}}\" class=\"label\" style=\"background-color: {{row.entity." + field_name + "}};color:{{row.entity." + field_name + "}}; display:block; margin-left: {{row.entity." + tree_level + "}}0px \">&nbsp;</span></div>";

            //return "<div class=\"ui-grid-cell-contents\" ng-switch=\"row.entity.message_level\"><span id=\"{{row.entity." + tree_level + "}}\" class=\"label\" style=\"background-color: {{row.entity." + field_name + "}};color:{{row.entity." + field_name + "}}; display:block; margin-left: {{row.entity." + tree_level + "}}0px \">{{row.entity." + field_name + "}}</span></div>";
        },
        stateTaskTemplate: function (code, name) {
            //<div ng-repeat='user in row.entity." + users + "'>{{ user.id }}</div>
            return "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + code + " == 'PENDING'\"><label>{{row.entity." + name + "}}</label></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + code + " == 'IN_PROGRESS'\"><label>{{row.entity." + name + "}}</label></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + code + " == 'COMPLETED'\"><label>{{row.entity." + name + "}}</label></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + code + " == 'CANCELED'\"><label>{{row.entity." + name + "}}</label></div>";
           
        },
        customStringTemplate: function (objectValues, separator) {
            var returnTemplate = "";
            if (typeof (separator) !== "undefined") separator = " ";
            angular.forEach(objectValues, function (item) {
                if (item !== "" && item !== null) {

                    returnTemplate += (returnTemplate == ""
                                        ? '<span ng-if="row.entity.' + item + '!=\'\' && row.entity.' + item + '!=null "> {{row.entity.' + item + '}}</span>'
                                        : '<span ng-if="row.entity.' + item + '!=\'\' && row.entity.' + item + '!=null">' + separator + ' {{row.entity.' + item + '}}</span>');
                }

            });
            return "<div class=\"ui-grid-cell-contents\" >" + returnTemplate + "</div>";
        },
        customReplaceTemplate: function (item, separator1, separator2) {
            var returnTemplate = "";
            var textValue = "";
            if (typeof (separator1) !== "undefined") separator1 = "";
            if (typeof (separator2) !== "undefined") separator2 = "";
            if (item !== "" && item !== null) {
                textValue = '{{row.entity.' + item + '}}';
                textValue = textValue.replace(separator1, separator2);
                returnTemplate += textValue;
            }
            return "<div class=\"ui-grid-cell-contents\" >" + returnTemplate + "</div>";
        },
        entityTypeTemplate: function (propertyName) {
            //$filter('translate')('tasks_status.delete_message')

            return "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'events'\"><span>" + $filter('translate')('entity_types.events') + "</span></div>" +

                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'persons'\"><span>" + $filter('translate')('entity_types.persons') + "</span></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'correspondence'\"><span>" + $filter('translate')('entity_types.correspondence') + "</span></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'restaurants'\"><span>" + $filter('translate')('entity_types.restaurants') + "</span></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'general'\"><span>" + $filter('translate')('entity_types.general') + "</span></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'documents'\"><span>" + $filter('translate')('entity_types.documents') + "</span></div>" +
                "<div class=\"ui-grid-cell-contents\" ng-if=\"row.entity." + propertyName + " == 'staff'\"><span>" + $filter('translate')('entity_types.staff') + "</span></div>";
        },

    };
    return service;
}]);